import "./HowWeWork.css";
import { FaSearch, FaFileAlt, FaUniversity, FaPlane, FaHandshake } from "react-icons/fa";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const HowWeWork = () => {
  const stepsRef = useRef([]);

  useEffect(() => {
    stepsRef.current.forEach((step, index) => {
      gsap.fromTo(
        step,
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 1, ease: "power2.out", scrollTrigger: { trigger: step, start: "top 80%" } }
      );
    });
  }, []);

  return (
    <section className="how-we-work">
      <div className="container">
        <h2>How We Work</h2>
        <div className="steps">
          {[ 
            { icon: <FaSearch className="icon" />, title: "Step 1: Consultation", text: "We understand your needs and help you choose the right country and university." },
            { icon: <FaFileAlt className="icon" />, title: "Step 2: Documentation", text: "We assist you with preparing all required documents for applications." },
            { icon: <FaUniversity className="icon" />, title: "Step 3: University Admission", text: "We help you secure admission to your preferred university." },
            { icon: <FaPlane className="icon" />, title: "Step 4: Visa Process", text: "Our team guides you through the visa application and approval process." },
            { icon: <FaHandshake className="icon" />, title: "Step 5: Final Departure", text: "We assist you with travel arrangements and pre-departure guidance." }
          ].map((step, index) => (
            <div className="step" key={index} ref={el => stepsRef.current[index] = el}>
              {step.icon}
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;